var _defs, _g, _polyline, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.5,
    height: 160,
    viewBox: "0 0 329.5 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-2",
    d: "m0,0v159.9h159.9V0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-2",
    d: "m169.8,0v160h159.7V0h-159.7Z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "polyline46",
    className: "cls-1",
    points: "101.2 9.2 101.2 106.8 110.8 106.8 110.8 9.2 150.8 9.2 150.8 150.7 59.5 150.7 59.5 58.1 49.9 58.1 49.9 150.7 9.6 150.7 9.6 9.2"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "polyline48",
    className: "cls-1",
    points: "320.3 9.3 320.3 54.7 224.7 54.7 224.7 64.4 320.3 64.4 320.3 100.6 224.7 100.6 224.7 110.3 320.3 110.3 320.3 150.6 179 150.6 179 9.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.36d2fe2b5085e304c40ffda82cb3ba64.svg";
export { ForwardRef as ReactComponent };